enum SortOption {
  Name,
  Price,
  Amount,
  Date,
  Brand,
}
export default SortOption
